import React from 'react';
import GoldenEyeCareLayout from './components/layout/layout';

const EndedPage = () => {
    return (
        <GoldenEyeCareLayout activePage="ended" skipEndDate={false} isEndedPage={true}>
            <div style={{ 
                minHeight: '300px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                textAlign: 'center',
                padding: '20px'
            }}>
                <h2>活動已結束，感謝您的參與。</h2>
            </div>
        </GoldenEyeCareLayout>
    );
};

export default EndedPage;
